import { Injectable } from '@angular/core';
import { BaseHttpWithBundleService } from '@app/core/services/base/base-service-with-bundle.service';
import { HttpServiceBundle } from '@app/core/services/base/http-service-bundle.service';
import { ClientUserUriBuilderParams, UserService } from '@app/core/services/user.service';
import { AuthenticationService } from '@app/core/authentication';
import { User } from '@app/shared/models/user';
import { Observable } from 'rxjs';
import { ClientUser } from '@app/shared/models/client-user';
import { DRResponse } from '@app/shared/models/response';
import { BackendUriUnits } from '@app/core/services/base/backend-uri-units';


@Injectable({
    providedIn: 'root'
})
export class PersonalService extends BaseHttpWithBundleService {

    get currentUser(): User {
        return this.authenticationService.currentUserValue;
    }

    public constructor(protected httpServiceBundle: HttpServiceBundle,
                       public userService: UserService,
                       protected authenticationService: AuthenticationService) {
        super(httpServiceBundle);
    }

    public getMyUserData(): Observable<ClientUser> {
        return this.userService.getById(new ClientUserUriBuilderParams(this.currentUser.client, this.currentUser.user.id));
    }

    public saveMyUserData(updated: ClientUser): Observable<ClientUser> {
        return this.userService.update(new ClientUserUriBuilderParams(this.currentUser.client, this.currentUser.user.id), updated);
    }

    public updateMyPassword(currentPassword, newPassword): any {
        const passwordResetUri = `${this.uri.replace('/smp', '')}/${BackendUriUnits.CLIENTS}/${BackendUriUnits.USER}/changePassword`;

        return this.http.put<DRResponse<any>>(passwordResetUri, {
            old_password: currentPassword,
            new_password: newPassword,
            new_password_confirmation: newPassword
        }).pipe();
    }
}
